import { Context, Func, Macro, SqlExpression } from '../../types';
import { ASTCall, ASTExpr } from '../../ast';
import { TypecheckWarning, typecheckExpression } from '../../typecheck';
import { evalExpression } from '../../eval';
import { ExprType } from '../../expr_types';
import { exprToSql } from '../../sql';

export type MacroArgs = {
  expand(call: ASTCall): ASTExpr;
  typecheck?(
    ctx: Context,
    call: ASTCall,
    warnings?: Array<TypecheckWarning>
  ): ExprType;
  customTraceHook?(
    ctx: Context,
    call: ASTCall,
    eSql: SqlExpression
  ): SqlExpression;
};

export function macro(args: MacroArgs): Macro {
  return {
    typecheck(
      ctx: Context,
      call: ASTCall,
      warnings?: Array<TypecheckWarning>
    ): ExprType {
      let ty: ExprType | undefined = undefined;
      if (args.typecheck) {
        ty = args.typecheck(ctx, call, warnings);
      }
      const expanded = args.expand(call);
      ty ??= typecheckExpression(ctx, expanded, warnings);
      return ty;
    },
    expand(call: ASTCall): ASTExpr {
      return args.expand(call);
    },
    eval(ctx: Context, call: ASTCall): unknown {
      const expanded = args.expand(call);
      return evalExpression(ctx, expanded);
    },
    toSql(ctx: Context, call: ASTCall): SqlExpression {
      const expanded = args.expand(call);
      const eSql = exprToSql(ctx, expanded);
      if (args.customTraceHook) {
        return args.customTraceHook(ctx, call, eSql);
      }
      return eSql;
    },
  };
}

export function isMacro(func: Func): func is Macro {
  return 'expand' in func;
}
